import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  name: FelaCSS;
  who: FelaCSS;
  stats: FelaCSS;
  typeWrap: FelaCSS;
  rating: FelaCSSWithCustomSelectors;
  date: FelaCSS;
  externalFeedback: FelaCSS;
  splitterVertical: FelaCSS;
  contentWrap: FelaCSS;
  title: FelaCSS;
  imageWrap: FelaCSS;
  topContainer: FelaCSS;
  leftContainer: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '24px',
    paddingBottom: '24px',
    backgroundColor: colors.white,

    maxWidthTabletSm: {
      flexDirection: 'column',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px',
      paddingBottom: '16px',
    },
  },
  name: {
    marginBottom: '3px',
    fontDefaultSemiBold: 12,
    lineHeight: '14px',
    color: colors.space,
  },

  who: {
    fontDefault: 12,
    lineHeight: '14px',
    color: colors.space60,

    maxWidthTabletSm: {
      marginBottom: '16px',
    },
  },

  stats: {
    marginTop: 2,
    maxWidthTabletSm: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '8px',
    },
  },

  typeWrap: {
    marginBottom: '8px',

    maxWidthTabletSm: {
      marginBottom: '0',
    },
  },

  rating: {
    flexDirection: 'row',
    alignItems: 'center',
    '> .rating-wrap': {
      '> span': {
        '> span': {
          fontDefault: 18,

          '> span': {
            '> .icon.full': {
              fontDefault: 19,
            },
          },
        },
      },
    },
  },

  date: {
    fontDefault: 10,
    lineHeight: '20px',
    color: colors.space60,
  },

  externalFeedback: {
    fontDefault: 10,
    lineHeight: '20px',
    color: colors.space60,
  },

  splitterVertical: {
    flexShrink: 0,
    marginLeft: '24px',
    marginRight: '24px',
    width: '1px',
    backgroundColor: colors.space15,

    maxWidthTabletSm: {
      display: 'none',
    },
  },

  contentWrap: {
    flexGrow: 1,
  },

  title: {
    marginBottom: '8px',
    fontDefaultSemiBold: 20,
    lineHeight: '24px',
    color: colors.space,
  },

  imageWrap: {
    marginBottom: '8px',
  },
  topContainer: {
    flexDirection: 'column',

    maxWidthTabletSm: {
      flexDirection: 'row',
      borderBottom: `1px solid ${colors.space15}`,
    },
  },
  leftContainer: {
    flexShrink: 0,
    width: '150px',
    flexDirection: 'column',
    maxWidthTabletSm: {
      width: 'unset',
    },
  },
});

export default styles;
